import { Typography } from '@mui/material';
import { Hazard } from 'features/hazards/hazard.types';

type HazardEmbedContentProps = {
  geoEvent: Hazard;
};

export const HazardEmbedContent = ({
  geoEvent,
}: HazardEmbedContentProps): JSX.Element | null => {
  const { address } = geoEvent;

  if (!address) return null;

  return <Typography>{address}</Typography>;
};
